import { fetch } from '@/utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryWebsiteTransportInfos(
  {
    page, size, direction, sort,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-transport-infos`,
    method: 'get',
    params: {
      page,
      size,
      direction,
      sort,
    },
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryWebsiteTransportInfo(transportInfoId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-transport-infos/${transportInfoId}`,
    method: 'get',
  });
}

/**
 * 新增
 * @param  locations
 * @param  baseWeight
 * @param  postage
 * @param  unitWeight
 * @param  unitPostage
 * @param currencyCode
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _addWebsiteTransportInfo(
  {
    locations,
    baseWeight,
    postage,
    unitWeight,
    unitPostage,
    currencyCode,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-transport-infos`,
    method: 'post',
    data: {
      locations,
      baseWeight,
      postage,
      unitWeight,
      unitPostage,
      currencyCode,
    },
  });
}

/**
 * 更新
 * @param transportInfoId
 * @param  locations
 * @param  baseWeight
 * @param  postage
 * @param  unitWeight
 * @param  unitPostage
 * @param currencyCode
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updateWebsiteTransportInfo(transportInfoId, {
  locations,
  baseWeight,
  postage,
  unitWeight,
  unitPostage,
  currencyCode,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-transport-infos/${transportInfoId}`,
    method: 'patch',
    data: {
      locations,
      baseWeight,
      postage,
      unitWeight,
      unitPostage,
      currencyCode,
    },
  });
}

/**
 * 删除
 * @param transportInfoId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deleteWebsiteTransportInfo(transportInfoId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-transport-infos/${transportInfoId}`,
    method: 'delete',
  });
}

export default {};
